import { getStore } from '@/slices/store';
import { getValidTokenSet } from '@/slices/features/tokenSet/tokenSetSlice';
import log from '../logger';

const MAX_ATTEMPTS = 3;

export async function getUserAccessToken(currentAttempt: number = 1): Promise<any> {
  const store = getStore();
  const state = store.getState();
  const tokenSet = state.tokenSet.tokenSet;

  if (tokenSet) {
    const newTokenSet = await store.dispatch(getValidTokenSet()).unwrap();
    if (!newTokenSet) {
      throw new Error('Failed to get valid token set');
    }
    return `Bearer ${newTokenSet.access_token}`;
  } else {
    if (currentAttempt < MAX_ATTEMPTS) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      return getUserAccessToken(currentAttempt + 1);
    } else {
      log.error('Token is not present after maximum attempts');
    }
  }
}
